// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AreaMCP
export var ContextMCPTool;
(function (ContextMCPTool) {
    ContextMCPTool["collectAgentFeedback"] = "collect_agent_feedback";
    ContextMCPTool["getMe"] = "get_me";
    ContextMCPTool["search"] = "search";
    ContextMCPTool["getAssetList"] = "get_asset_list";
    ContextMCPTool["getAssetDetail"] = "get_asset_detail";
    ContextMCPTool["getDesignSystemComponentList"] = "get_design_system_component_list";
    ContextMCPTool["getDesignSystemComponentDetail"] = "get_design_system_component_detail";
    ContextMCPTool["getDocumentationPageList"] = "get_documentation_page_list";
    ContextMCPTool["getDocumentationPageContent"] = "get_documentation_page_content";
    ContextMCPTool["getKnowledgeFileList"] = "get_knowledge_file_list";
    ContextMCPTool["getKnowledgeFileDetail"] = "get_knowledge_file_detail";
    ContextMCPTool["getKnowledgeSkillList"] = "get_knowledge_skill_list";
    ContextMCPTool["getKnowledgeSkillDetail"] = "get_knowledge_skill_detail";
    ContextMCPTool["getFigmaComponentList"] = "get_figma_component_list";
    ContextMCPTool["getFigmaComponentDetail"] = "get_figma_component_detail";
    ContextMCPTool["getProjectFeatureArtifactDetails"] = "get_project_feature_artifact_details";
    ContextMCPTool["getSelectedProjectDocumentDetails"] = "get_selected_project_document_details";
    ContextMCPTool["getSelectedProjectFeatureDetails"] = "get_selected_project_feature_details";
    ContextMCPTool["getStorybookStoryList"] = "get_storybook_story_list";
    ContextMCPTool["getStorybookStoryDetail"] = "get_storybook_story_detail";
    ContextMCPTool["getTokenList"] = "get_token_list";
    ContextMCPTool["getTokenDetails"] = "get_token_details";
    ContextMCPTool["getTokenThemeList"] = "get_token_theme_list";
    ContextMCPTool["getCodeComponentList"] = "get_code_component_list";
    ContextMCPTool["getCodeComponentDetail"] = "get_code_component_detail";
})(ContextMCPTool || (ContextMCPTool = {}));
export class AreaMCP {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /**
     * Invokes a context-scoped MCP tool.
     * @param contextId - The context ID whose MCP scope should be used.
     * @param invocation - The MCP tool to invoke and its tool-specific payload.
     * @param options.endpoint - Optional fully qualified MCP endpoint to call.
     * @returns The textual MCP tool response.
     */
    invokeContextMCPTool(contextId, invocation, options) {
        if (!contextId || !invocation.tool) {
            return Promise.resolve("");
        }
        return this.dataCore.invokeContextMCPTool(contextId, invocation.tool, invocation.payload, options === null || options === void 0 ? void 0 : options.endpoint);
    }
    /**
     * Retrieves an MCP stream by ID. Users can only access MCP streams associated with themselves.
     * @param streamId - The ID of the MCP stream to retrieve.
     * @returns The MCPStream object.
     */
    async getMCPStream(streamId) {
        return this.dataCore.getMCPStream(streamId);
    }
    /**
     * Retrieves the user's MCP stream. If no MCP stream exists for the user, an empty MCP stream is created automatically.
     * @returns The user's MCPStream object.
     */
    async getUserMCPStream() {
        return this.dataCore.getUserMCPStream();
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Write
    /**
     * Updates the user's MCP stream with the provided data.
     * @param data - The update input containing optional projectFeatureId and projectDocumentId.
     * @returns The updated MCPStream object.
     */
    async updateUserMCPStream(data) {
        return this.dataCore.updateUserMCPStream(data);
    }
}
